// extracted by mini-css-extract-plugin
export default {"content":"FJ-z","lookName":"GJ-z","shopTheLookContainer":"HJ-z","productContainer":"IJ-z","imageContainer":"JJ-z","mainImage":"KJ-z"};